<template>
  <div>
    <el-container v-loading.fullscreen.lock="status"
                  :element-loading-text="message"
                  element-loading-background="rgba(255, 255, 255, 0.75)"
                  :class="{ 'blur': animate === true }">

      <vue-progress-bar></vue-progress-bar>

      <el-header>
        <el-row type="flex" justify="space-between">
          <el-col :span="2">
            <div>
              <p class="logo-sre" style="{background-image: url('/img/sre_new_header2.png');}"></p>
            </div>
          </el-col>
          <el-col :span="8">
            <b class="logo-gmm" style="font-size: 10pt !important; color: #e6d194 !important;">
              <span>MÓDULO DE SERVICIOS EN EL EXTERIOR {{versionApp}}</span>
            </b>
          </el-col>
          <el-col :span="13">
            <el-menu :router="true"
                     class="header-menu"
                     mode="horizontal"
                     background-color="#611232"
                     text-color="#e6d194"
                     active-text-color="#FFFFFF"
                     style="float: right;">
              <el-menu-item index="/" class="remove-hover">
                <i class="fas fa-home"></i>
              </el-menu-item>
              <el-menu-item index="/help" class="remove-hover">
                <i class="fas fa-question"></i>
              </el-menu-item>
              <el-menu-item index="/" class="remove-hover">
                                <span style="font-size: 8pt !important;">
                                {{ userFullName | truncateCustom(15) }}
                                <i class="fas fa-user"></i>
                                </span>
              </el-menu-item>

              <el-menu-item index="/" class="remove-hover"
                            v-if="infoUser && infoUser.informatics && infoUser.informatics.length==0">
                                <span style="font-size: 8pt !important;">
                                    {{ officeName | truncateCustom(25) }}
                                </span>
              </el-menu-item>

              <el-menu-item index="/" class="remove-hover"
                            v-if="infoUser && infoUser.informatics && infoUser.informatics.length>0">
                <el-select
                    style="width:100%"
                    v-model="infoUser.cat_office_id"
                    @change="setUpdateOffice()"
                    filterable
                    placeholder="Seleccionar">
                  <el-option
                      v-for="(item,key) in infoUser.informatics"
                      :key="key"
                      :label="item.representation_name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-menu-item>
              <el-menu-item index="#" @click="logOut" class="remove-hover">
                <i class="fas fa-sign-out-alt"></i>
              </el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
      </el-header>

      <el-row type="flex" v-if="show === true && progressBar" justify="center">
        <el-col style="padding: 20px;" :span="24">
          <el-progress
              :percentage="progressBar.percentage"
              :text-inside="true"
              :stroke-width="18"
              status="success">
          </el-progress>
        </el-col>
      </el-row>

      <el-container>

        <el-main class="bannerMain" id="body-content">


          <el-card :body-style="{ padding: '0px' }" shadow="never" style="border-top-left-radius:0px;">
            <router-view style="padding: 0.5em"></router-view>
          </el-card>

        </el-main>
      </el-container>
    </el-container>
  </div>

</template>

<script>
import {mapState, mapGetters} from "vuex";

export default {

  data() {
    return {
      show: false,
      animate: false,
      officeName: '',
      versionApp: ''
    };
  },

  computed: {
    ...mapState([
      'route'
    ]),
    userFullName() {
      return this.$store.state.user.fullname;
    },
    infoUser() {
      return this.$store.state.user
    },
    ...mapGetters('form', {
      progressBar: 'progressBar',
    }),
    ...mapGetters('loading', ['message', 'status']),
  },
  methods: {



    setUpdateOffice() {

      this.showLoading();
      let data = {
        office_id: this.infoUser.cat_office_id
      };

      axios.post('/api/user-update-office', data).then((response) => {
        this.hideLoading();
        if (response.data.success) {
          this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          this.$store.dispatch('notifications/error', {msg: 'No se pudo completar la acción.'}, {root: true});
        }
      }).catch((errror) => {
        this.hideLoading();
        this.$store.dispatch('notifications/error', {msg: 'No se pudo completar la acción.'}, {root: true});
      });
    },
    showLoading() {
      this.$store.dispatch(
          "loading/spinner",
          {msg: "Cargando Datos...", status: true},
          {root: true}
      );
    },
    hideLoading() {
      this.$store.dispatch("loading/spinner", {}, {root: true});
    },

    logOut() {
      let _this = this;

      _this.showLoading();

      axios.post("/api/logout").then(response => {

        if (response.data.authenticated === false) {
          sessionStorage.removeItem("acquisition_token");
          sessionStorage.removeItem("acquisition_token_expiration");
          sessionStorage.removeItem("acquisition_keep_session");
          sessionStorage.removeItem("acquisition_user");

          sessionStorage.removeItem("acquisition_session_message");
          sessionStorage.removeItem("acquisition_session_time");
          sessionStorage.removeItem("user");

          _this.$store.commit('deleteUser', response.data.user);

          axios.defaults.headers.common = {
            'Authorization': "Bearer",
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Accept-C': window.acceptC
          };

          _this.hideLoading();

          _this.$router.push("/ingresar");
        } else {
          _this.hideLoading();

          _this.$message({
            type: "warning",
            message: "No fue posible cerrar su sesión, inténtelo nuevamente."
          });
        }
      }).catch(e => function () {
        _this.hideLoading();

        _this.$message({
          type: "warning",
          message: "No fue posible cerrar su sesión, inténtelo nuevamente."
        });
      });
    },
    init() {
      this.show = !!(this.route && this.route.name && (this.route.name == 'solicitudesAlta'
          || this.route.name == 'solicitudesEditar'));
      setTimeout(() => {
        this.officeName = this.infoUser.office.representation_name;
      }, 2500)
    }

  },
  created() {
    this.versionApp = window.versionApp
    this.init();
  },
  watch: {
    $route: 'init',
  },
};
</script>
<style>

.remove-hover:hover {
  background: #9D2449 !important;
  cursor: pointer;
  color: #e6d194 !important;
}

/* Content */
.el-container {
  height: 100vh;
}

.logo-gmm:hover {
  cursor: pointer;
  opacity: 0.75;
}

.header-menu {
  margin-right: -20px
}

/* Side menu */
.el-aside {
  height: 100%
}

.el-menu {
  border: none;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 225px;
}

.el-aside-menu-icon {
  vertical-align: middle;
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
}

/* Content wrapper */
.content-wrapper {
  border: 16px solid #E9EEF3;
  background-color: #FFF;
  height: 100%;
}

.menu-notification {
  background-color: #FFBF00;
  width: 50px;
  height: 56px;
  text-align: center;
  border-bottom: 4px solid #DB2828 !important;
}


@media screen and ( min-height: 768px ) {
  /* Content */
  .el-container {
    height: 768px
  }
}

@media screen and ( min-height: 896px ) {
  /* Content */
  .el-container {
    height: 896px
  }
}

@media screen and ( min-height: 912px ) {
  /* Content */
  .el-container {
    height: 912px
  }
}

@media screen and ( min-height: 1024px ) {
  /* Content */
  .el-container {
    height: 1024px
  }
}

@media screen and ( min-height: 1180px ) {
  /* Content */
  .el-container {
    height: 1180px
  }
}

@media screen and ( min-height: 1280px ) {
  /* Content */
  .el-container {
    height: 1280px
  }
}
</style>
